import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useTranslation } from 'react-i18next'

import Layout from '../../components/Layout'
import LoadingSpinner from 'components/Shared/LoadingSpinner'
import useIsFirstRender from 'hooks/useFirstRender'
import authApi from 'api/auth'
import ErrorMessage from 'components/Shared/ErrorMessage'
import GoogleAccess from 'components/Settings/Google'
import { ExpandedLogoWhiteIcon } from 'images'

export function AnonymousGoogleLogin({ match }) {
  const { language } = match.params
  const [accessToken, setAccessToken] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const firstRender = useIsFirstRender()
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (!firstRender) return

    if (language && ['en', 'de'].includes(language)) {
      i18n.changeLanguage(language)
    }
  }, [firstRender, i18n, language])

  useEffect(() => {
    if (!firstRender) return

    const searchParams = new URLSearchParams(window.location.search)
    const authCodeParam = searchParams.get('code')

    if (!authCodeParam) {
      setError('fd.error.missingAuthCode')
    } else {
      setLoading(true)
      authApi
        .getAnonymousToken(authCodeParam)
        .then((response) => {
          setLoading(false)
          const { data, error: responseError } = response
          if (responseError) {
            console.error(responseError)
            setError('fd.error.invalidAuthCode')
            return
          }
          setAccessToken(data.access_token)
          sessionStorage.setItem('anonymous-session', JSON.stringify(data))
        })
        .catch((err) => {
          console.error(err)
          setLoading(false)
          setError('fd.error.invalidAuthCode')
        })
    }
  }, [firstRender])

  return (
    <Layout title="Google Ads">
      <Helmet bodyAttributes={{ class: '' }} />
      <div>
        <header
          style={{
            backgroundColor: '#031c41',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ExpandedLogoWhiteIcon height="31" alt="fd" />
        </header>
        <main className="third-party-fb-login pt-5">
          <div className="container-fluid h-100 mb-5">
            <div className="d-flex flex-column align-items-center justify-content-center h-100">
              {error && (
                <div>
                  <ErrorMessage danger>{t('common.genericError')}</ErrorMessage>
                </div>
              )}
              {loading && <LoadingSpinner showText={false} />}
              {accessToken && (
                <div className="col-12 col-lg-9 mx-auto settings-page__container">
                  <GoogleAccess isAnonymous />
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

AnonymousGoogleLogin.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      language: PropTypes.string,
    }),
  }),
}
